<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column bg-documentGray">              
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="routerGoPrev(examActions)">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title" v-if="type=='formal-evolution'" >
                                {{$t('1230')}}
                            </div>     
                             <div class="mdc-top-app-bar__title" v-else-if="type === 'regular-evolution'" >
                                {{$t('1231')}}
                            </div> 
                             <div class="mdc-top-app-bar__title" v-else>
                                {{$t('1232')}}
                            </div>            
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                </header>
                <section class="flex-grow-1 scroll-y">
                    <div class="pda-default">
                        <div class="t-headline9">
                            {{examName}}
                            <!-- 비즈니스 전문가 과정 설문 조사: 예측 가능한 분석 -->
                        </div>

                        <div class="d-grid mgt-16">
                            <div class="mdc-card mdc-elevation--z3 grid-row-1" style="height: 120px;">
                                <div class="pda-default text-center">
                                    <div class="t-headline9">
                                        {{examLevel || '-'}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1233')}}
                                        <!-- Test paper level -->
                                    </div>

                                </div>
                            </div>

                            <div class="mdc-card mdc-elevation--z3 grid-row-1" style="height: 120px;">
                                <div class="pda-default text-center">
                                    <div class="t-headline9">
                                        {{examQuestionCount}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1234')}}
                                        <!-- Number of tests -->
                                    </div>

                                </div>
                            </div>
                        </div>


                        <div class="d-grid mgt-16">
                            <div class="mdc-card mdc-elevation--z3 grid-row-1" style="height: 120px;">
                                <div class="pda-default text-center">
                                    <div class="t-headline9">
                                        {{examRetakeStatus}}
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1235')}}
                                        <!-- Retake -->
                                    </div>

                                </div>
                            </div>

                            <div class="mdc-card mdc-elevation--z3 grid-row-1" style="height: 120px;">
                                <div class="pda-default text-center">
                                    <div class="t-headline9">
                                        <div v-if="!examAverageTime">
                                            -
                                        </div>
                                        <div v-else>
                                            {{examAverageMin}}<span class="t-body3">{{$t('1236')}}</span>
                                            {{examAverageSec}}<span class="t-body3">{{$t('1237')}}</span>
                                        </div>
                                    </div>
                                    <div class="t-body3 t-color-bodyGrayA mgt-21">
                                        {{$t('1238')}}
                                        <!-- Average time -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="pdt-0 pdl-16 pdr-16 mgb-34">
                    <div v-for="(action, index) in examActions" :key="index" class="mgt-16">

                        <button class="mdc-button mdc-button--raised btn-red  w-full" :disabled="setButtonDisabled(action)" @click="examAction(action)" v-if="action.action === 'can_start' || action.action === 'can_re_start'">
                            {{setButtonActionName(action)}}
                        </button>    
                        <button class="mdc-button mdc-button--raised bg-white t-color-secondaryBtnText w-full " :disabled="setButtonDisabled(action)" @click="examAction(action)" v-else>
                            {{setButtonActionName(action)}}
                        </button> 
                        <!-- {{setButtonActionName(action)}}dddddd -->
                        <!-- <button class="mdc-button mdc-button--raised btn-red  w-full" :disabled="setButtonDisabled(action)" @click="examAction(action)">
                            {{setButtonActionName(action)}}
                        </button>     -->
                    </div>
                </section>
                
                
            </div>
        </div>
    </div>

    
</template>

<script>
/**
 * 시험 응시 인트로 컴포넌트(exam take intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'

export default {
    name: 'examContainer',
    components: {
        
    },

    mixins: [examMixin],

    data() {
        return {
            examData: null,
            examTitle: '',
            examName : '',
            examLevel : '',
            examNumber : '',
            examRetake : '',
            examAverageMin : 0,
            examAverageSec : 0,
            examAverageTime: 0,
            examQuestionCount: 0,
            progressionValue: '',

            examSubmit: false,
            examCanStart: false,
            examOpenScore: false,

            examActions: [],
            type:null,
            
        }
    },
    
    created() {        
        this.fatchData()        
    },

    computed: {
        setTitle() {
            return this.examTitle || 'TEST'
        },

        examRetakeStatus() {
            return this.examRetake === 'ONCE' ? 'IMPOSSIBLE' : 'POSSIBLE'
        }
    },

    mounted() {
        this.type=this.$route.query.type;
        this.setMaterialUi()
    },
    methods: {
        // set data
        fatchData(componentName) {
            let params = this.setParams()
            // console.log('Study.vue fatchData')
            // call api exam intro
            examApi.examIntro(params).then((response) => {
                this.examData = response.data.data
                // console.log('examIntro', this.examData)                
                // console.log('this.examActions', this.examActions);

                // this.examTitle = this.examData.name
                this.examName = this.examData.name
                this.examLevel = this.examData.level ? this.examData.level.text : ''
                this.examNumber = this.examData.submitCount
                this.examRetake = this.examData.applicationTerms.value
                this.examAverageTime = this.examData.avgSolveTime
                this.examAverageMin = Math.floor(this.examData.avgSolveTime / 60)
                this.examAverageSec = this.examData.avgSolveTime - this.examAverageMin * 60
                this.examQuestionCount = this.examData.activityCount.question
                // this.progressionValue = this.examData.progression.value

                // console.log('this.examActions', this.examActions);

                this.examSubmit = this.examData.submit
                this.examCanStart = this.examData.canStart
                this.examOpenScore = this.examData.openScore
                this.examActions = this.examData.actions
                this.examActions.push()
            }).catch((err) => {
                
            })

        },
        
        // API 호출 파라미터 설정(set parameter)
        setParams() {
             let params = {
                examineeId: this.$route.params.examineeId
            }
            return params
        },
        
        setButtonActionName(action) {
            //before_start : ~부터 응시가능
            //can_start : 응시
            //can_re_start : 재응시
            //before_confirm : ~부터 결과확인 가능
            //open_confirm : 결과확인
            let buttonName = ''
            if (action.action === 'before_start') {
                buttonName = this.$t('50010', {str: action.data.application_start_time}) //  + '{날짜}부터 응시가능'
            }else if (action.action === 'can_start') {
                buttonName = this.$t('1239') //'응시'
            }else if (action.action === 'can_re_start') {
                buttonName = this.$t('1262') //재응시'
            }else if (action.action === 'before_confirm') {
                buttonName = this.$t('50011', {str: action.data.confirm_start_time}) // '~부터 결과확인 가능'
            }else if (action.action === 'open_confirm') {
                buttonName = this.$t('1263') //'결과확인'
            }
            return buttonName
        },

        setButtonDisabled(action) {
            return action.action === 'before_start' || action.action === 'before_confirm' ? true : false
        },

        examAction(action) {
            if (action.action === 'can_start' || action.action === 'can_re_start') {
                // 시험응시(exam take)
                this.startExam()
            }else if (action.action === 'open_confirm') {
                // 시험결과로 이동(move exam result)
                this.moveExamResult()
            }
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    },
    
}
</script>